jQuery(document).ready(function(){
    jQuery('.pgut-svg-map .pgut-svg-map__zones .pgut-svg-map__card')
        .each(function(){

            let $zone = jQuery(this);
            let $id = jQuery(this).prevAll().length + 1;
            let $map = $zone.parent().parent().find('.pgut-svg-map__svg');
            let $target_ids = $zone.attr('data-target').split(',');
            var $window = jQuery(window);
			//let target_ids = zone.attr('data-target');
            $zone.attr('data-info','data-info-'+$id);

            for(var i in $target_ids){
                let pin = $map.find('#'+$target_ids[i]);
                pin.addClass('pgut-map-zone').attr('data-info','data-info-'+$id);
            }

            let $close = jQuery('<span class="close-btn">Fermer</span>').appendTo($zone);
            $close.click(function(){
                if($window.width() >= 768)
                    jQuery(this).parent().fadeOut();
            })
        })
        .on('mouseleave',function(e){
            if($window.width() >= 768)
                jQuery(this).fadeOut();
        });

    var $map = jQuery('.pgut-svg-map .pgut-svg-map__svg').svgmap({
        selector : '.pgut-map-zone', // selecteur css pour les zones (path) cliquables
        active : '', // selecteur css de la zone active par défaut
        callbackInit : function ($map) {
            // la fonction de callback appelée lors de l'instanciation.
            // la var map est l'objet instancié
        },
        callbackMousenter : function ($zone,$map,event) {
            // la fonction de callback appelée lors du passage du curseur sur une zone.
            // la var zone est l'objet jQuery de la zone survolée
            // la var map est l'objet instancié
        },
        callbackMouseleave : function ($zone,$map,event) {
            // la fonction de callback appelée lors du départ du curseur depuis une zone.
            // la var zone est l'objet jQuery de la zone survolée
            // la var map est l'objet instancié
        },
        callbackClick : function ($zone,$map,event) {
            // la fonction de callback appelée lors du clic sur une zone.
            // la var zone est l'objet jQuery de la zone survolée
            // la var map est l'objet instancié
            let $window = jQuery(window);
            let $info_id = $zone.attr('data-info');
            let $map_info = $map.parent().parent().find('.pgut-svg-map__zones .pgut-svg-map__card[data-info="'+ $info_id +'"]');
            let $relX = event.pageX - $map.offset().left;
            let $relY = event.pageY - $map.offset().top;

            let $checkLeft = ( $relX - ($map_info.width()/2) -50);
            let $checkRight = ( $relX + ($map_info.width()/2) + 50);

            if( $map_info.is('.is_auto_open') ){
                let $href_link = $map_info.find('a').attr('href');
                window.location.href = $href_link;
                return;
            }

            if($window.width() > 500)
            {
                $map_info.css('left',$relX).css('top',$relY).fadeIn();
                if(  $checkLeft < 0 )
                    $map_info.addClass('onLeft');
                else if( $checkRight > $window.width() )
                    $map_info.addClass('onRight');
            }
            else{
                $map_info.addClass('fixedPos').fadeIn();
            }
        }
    });
})